<template>
   <div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else class="text-center">
         <div v-if="ruches.length === 0" style="text-align:center">Aucun élément à afficher</div>
         <div class="text-center" style="margin:20px 0 ;font-weight:700">
            <div v-if="ruches.length > 10">
               Veuillez supprimer encore
               <span style="color:red">{{ ruches.length - 10 }}</span> ruche(s).
            </div>
            <div v-else>
               <router-link :to="{name:'dashboard'}">
                  <b-button icon-left="thumb-up" type="is-primary">Retour sur l'application</b-button>
               </router-link>
            </div>
         </div>
         <div class="liste" style="max-width:700px;margin:auto">
            <div v-for="ruche in ruches" :key="ruche.id" class="liste-item">
               <div>
                  {{ ruche.nom }}
                  <b-icon icon="star" size="is-small" type="is-warning" v-if="ruche.elite" />
               </div>
               <div class="liste-icones">
                  <div @click.stop="deleteRuche(ruche.nom, ruche.id)">
                     <b-icon icon="delete" class="del"></b-icon>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="text-center" style="margin:20px 0 ">
         <b-button
            size="is-medium"
            type="is-light"
            icon-left="arrow-left"
            @click="$emit('reset')"
         >Retour</b-button>
      </div>
   </div>
</template>

<script>
   import axios from "axios";
   import { BeatLoader } from "@saeris/vue-spinners";

   export default {
      components: { BeatLoader },
      data() {
         return {
            loading: true,
            ruches: []
         };
      },
      mounted() {
         this.getRuches();
      },
      methods: {
         async getRuches() {
            this.loading = true;
            axios.defaults.headers.common["Authorization"] =
               "Bearer " + this.$store.state.token;
            let res = await axios.get("/ruches");
            this.ruches = res.data.data;
            this.loading = false;
         },
         deleteRuche(nom, id) {
            this.$buefy.dialog.confirm({
               message:
                  "Souhaitez-vous vraiment supprimer: " +
                  nom +
                  " ? Vous supprimerez également son historiques et les statistiques associées. Cette action est irréversible.",
               cancelText: "Non",
               confirmText: "Oui",
               type: "is-danger",
               hasIcon: true,
               onConfirm: () => {
                  this.loading = true;
                  axios.delete("/ruches/" + id).then(res => {
                     if (res.data.erreur) {
                        this.$buefy.toast.open({
                           message: res.data.erreur,
                           type: "is-danger"
                        });
                        this.getRuches();
                     } else {
                        this.$buefy.toast.open({
                           message: "Ruche supprimée avec succès",
                           type: "is-success"
                        });
                        this.loading = false;
                        this.ruches = this.ruches.filter(ruche => ruche.id != id);
                        if (this.ruches.length < 11) {
                           this.$router.push({ name: "dashboard" });
                        }
                     }
                  });
               }
            });
         }
      }
   };
</script>
